<template>
    <!--协作组-->
    <div class="common-module-page">
        <div class="page">
            <CommonTitle :title="modelTitle" :dark="true" :page-index="filterData.pageIndex" :page-size="filterData.pageSize" :total="total" @changePage="changePage">
                <!-- <div class="course-title">
                    <span :class="[{'active': curTab === item.id}]" v-for="item in tagList" :key="item.id" @click="switchTag(item.id)">{{item.name}}</span>
                </div> -->
            </CommonTitle>
            <ul class="course-list" v-if="list.length" v-loading="loading">
                <li class="course-list-item" v-for="item in list" :key="item.id" @click="goDetail(item.groupId)">
                    <div class="list-item-link" v-link="linkUrl(item.groupId)">
                        <div class="list-item-img">
                            <LazyImage :src="item.groupLogo" className="img" />
                        </div>
                        <div class="list-item-content">
                            <div class="title flex-start">
                                <span class="name text-overflow" :title="item.groupName">{{ item.groupName }}</span>
                            </div>
                            <div class="group-info flex-start">
                                <div class="group-label">{{ `${roleName}：` }}</div>
                                <div class="group-name text-overflow" :title="`${roleName}：${item.managerCall}`">{{item.managerCall || ''}}</div>
                            </div>
                            <div class="flex-between course-operate">
                                <div class="flex-start"><img v-for="(img, key) in item.userIcons" :key="key" class="avatar" :src="img || config.defaultImg" alt=""><span class="join-num">{{item.groupUserNum}}人已加入</span></div>
                                <div class="sign">立即加入</div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <BigNoData v-else class="no-group" :info="`暂无${modelTitle}`" url="no-group@2x.png"/>
        </div>
    </div>
</template>
<script setup>
import CommonTitle from '@/components/home-common-title/common-index.vue'
import BigNoData from '@/components/no-data.vue'
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import { pageJump } from '@/global/location-transfer'
import { jumpHref } from '@/router/jumpHref.js';
import { handleStageSubject } from '@/lib/tools';

import { useStore } from 'vuex'
import { ref, reactive, onMounted, computed } from 'vue';

const props = defineProps({
    modelTitle: {
        type: String,
        default: ''
    },
    roleName: {
        type: String,
        default: '组长'
    }
})

const list = ref([]);
const store = useStore();

const tagList = ref([
    {
        id: 'time',
        name: '最新'
    },
    {
        id: 'hot',
        name: '最热'
    }
])

const curTab = ref('time');

const loading = ref(false);
let total = ref(0);
const filterData = reactive({
    pageIndex: 1,
    pageSize: 6
});

const obj = {
    type: 'network'
}

const getList = function(){
    loading.value = true
    G_transmit('getOtherGroupList', {
        name: 'getOtherGroupList',
        data: {
            ...filterData
        }
    }).then(res => {
        list.value = res?.data?.rows || [];
        total.value = res?.data?.total || 0
        loading.value = false
        console.log('group', list.value)
    }).catch(err => {
        console.log('error', err)
        loading.value = false;
    });
}
const changePage = (pageIndex) => {
    console.log('pageIndex1', pageIndex)
    filterData.pageIndex = pageIndex
    getList();
}


// 切换
function switchTag(tag = 'time') {
    curTab.value = tag;
    filterData.pageIndex = 1
    getList();
}


function goMore(){
    pageJump({name: 'groupIndex'})
}

function goDetail(id) {
    pageJump(jumpHref.group.detail(id), true);
}

function linkUrl(id){
    return {
        url: jumpHref.group.detail(id),
        className: 'link-item'
    }
}

onMounted(() => {
    switchTag('hot');
})

</script>

<style lang="scss" scoped>
.common-module-page {
    // width: 100vw;
    background: #F8F8F8;
    padding-bottom: 30px;
    .page {
        width: 1200px;
        margin: 0 auto;
    }
}
.course-list {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
}

.course-list-item {
    box-sizing: border-box;
    width: 386px;
    height: 120px;
    background: #FFFFFF;
    border-radius: 4px;
    margin-left: 20px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    padding-left: 6px;
    cursor: pointer;
    &:nth-child(1), &:nth-child(2), &:nth-child(3) {
        margin-top: 0;
    }
    &:nth-child(3n+1) {
        margin-left: 0;
    }
    &:hover {
        box-shadow: 0px 4px 12px 0px rgba(37,54,82,0.08);
    }

    .list-item-img {
        width: 108px;
        height: 108px;
        .img {
            width: 100%;
            height: 100%;
        }
    }

    .list-item-content {
        width: 0;
        flex: 1;
        position: relative;
        margin-left: 12px;
        padding-right: 16px;
        .title {
            white-space: nowrap;
        }
        .name {
            font-weight: bold;
            color: var(--srt-main-text-color);
            font-size: 16px;
            line-height: 24px;
        }
        .group-info {
            font-size: 14px;
            color: #222222;
            line-height: 19px;
            margin-top: 6px;
            .group-label {
                color: #666666;
            }
        }
        .course-operate {
            margin-top: 19px;
            .join-num {
                font-size: 14px;
                color: #666666;
                line-height: 19px;
                margin-left: 8px;
            }
            .avatar {
                width: 24px;
                height: 24px;
                border: 1px solid #FFFFFF;
                border-radius: 50%;
                &:nth-child(2), &:nth-child(3) {
                    margin-left: -8px;
                }
            }
            .sign {
                width: 72px;
                height: 28px;
                background: #E7F1FF;
                border-radius: 6px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #0084F6;
                line-height: 28px;
                text-align: center;
            }
        }
    }
}
:deep(.link-item){
    width:100%;
    .list-item-link{
        display: flex;
        align-items: center;
    }
}
.course-title {
    flex: 1;
    padding: 0px 30px;
    margin-bottom: 15px;
    color: var(--srt-color-gray);
    cursor: pointer;
    span {
        margin-right: 20px;
        &.active {
            color: var(--home-main-color);
        }
    }
}

.no-data {
    margin-top: 50px;
}
</style>